"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
class CurrencyProvider extends DataProvider_1.default {
    get fragments() {
        return {
            Currency: () => `
        ... on Currency {
          name
          rate
        }`,
        };
    }
    findAll() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.query({
                query: graphql_tag_1.default `
        query CurrencyFindAll {
          currencyFindAll {
            ${this.getFragment("Currency")}
          }
        }
      `,
            });
            return response.data.currencyFindAll;
        });
    }
    create({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.mutate({
                mutation: graphql_tag_1.default `
        mutation CurrencyCreate($data: InputCurrencyCreate!) {
          currencyCreate(data: $data) {
            ${this.getFragment("Currency")}
          }
        }
      `,
                variables: {
                    data,
                },
            });
            return response.data.currencyCreate;
        });
    }
    update({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.mutate({
                mutation: graphql_tag_1.default `
        mutation CurrencyUpdate($data: InputCurrencyUpdate!) {
          currencyUpdate(data: $data) {
            ${this.getFragment("Currency")}
          }
        }
      `,
                variables: {
                    data,
                },
            });
            return response.data.currencyUpdate;
        });
    }
    delete({ name }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.mutate({
                mutation: graphql_tag_1.default `
        mutation CurrencyDelete($name: String!) {
          currencyDelete(name: $name)
        }
      `,
                variables: {
                    name,
                },
            });
            return response.data.currencyDelete;
        });
    }
}
exports.CurrencyProvider = CurrencyProvider;
//# sourceMappingURL=CurrencyProvider.js.map